import icLegendCrowdLv1 from '../assets/images/trains/kinds/ic_legend_crowd_lv1.png';
import icLegendCrowdLv2 from '../assets/images/trains/kinds/ic_legend_crowd_lv2.png';
import icLegendCrowdLv3 from '../assets/images/trains/kinds/ic_legend_crowd_lv3.png';
import icLegendCrowdLv4 from '../assets/images/trains/kinds/ic_legend_crowd_lv4.png';
import icLegendCrowdLv5 from '../assets/images/trains/kinds/ic_legend_crowd_lv5.png';
import icLegendCrowdLv6 from '../assets/images/trains/kinds/ic_legend_crowd_lv6.png';

export const CROWD_LEVELS = [
  { level: 1, min: 0, max: 18, color: 'blue', icon: icLegendCrowdLv1, label: '座れる' },
  { level: 2, min: 19, max: 54, color: 'lightblue', icon: icLegendCrowdLv2, label: '席はいっぱい' },
  { level: 3, min: 55, max: 108, color: 'green', icon: icLegendCrowdLv3, label: 'すこし混み合う' },
  { level: 4, min: 109, max: 162, color: 'yellow', icon: icLegendCrowdLv4, label: '肩が触れ合う' },
  { level: 5, min: 163, max: 198, color: 'orange', icon: icLegendCrowdLv5, label: 'かなり混み合う' },
  { level: 6, min: 199, max: Infinity, color: 'red', icon: icLegendCrowdLv6, label: '非常に混雑' },
];

export function crowdLevelForRate(rate) {
  return CROWD_LEVELS.find(({ min, max }) => rate >= min && rate <= max) || null;
}

// 3両以下しか乗車率を取得できなかった場合に表示する代替文言。文言未確定のため仮置き。
export const CROWD_UNAVAILABLE_MESSAGE = '混雑度情報を取得できませんでした';
